import EPLCancellationModal from './EPLCancellationModal'
import '../EPLInterviewedModal/EPLInterviewedModal.sass'

export default EPLCancellationModal
